  export default {
    transformData(data) {
        // 基本递归处理逻辑
        const transformChildren = (children) => {
            return children.map(item => {
                const transformed = {
                    value: item.name,
                    label: item.name
                };

                if (item.childrens && item.childrens.length > 0) {
                    transformed.children = transformChildren(item.childrens);
                }

                return transformed;
            });
        };

        // 主体结构转换
        return {
            value: data.name,
            label: data.name,
            children: transformChildren(data.childrens || [])
        };
    }
    }